import { render, staticRenderFns } from "./AboutUS.vue?vue&type=template&id=95e6aa2e&scoped=true&"
import script from "./AboutUS.vue?vue&type=script&lang=js&"
export * from "./AboutUS.vue?vue&type=script&lang=js&"
import style0 from "./AboutUS.vue?vue&type=style&index=0&id=95e6aa2e&prod&lang=scss&"
import style1 from "./AboutUS.vue?vue&type=style&index=1&id=95e6aa2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e6aa2e",
  null
  
)

export default component.exports